var translate={
    en:{
        LandingRedesign: {
            navbar: {
                btn_card: 'Know Wirebit card',
                btn_login: 'Log in',
                btn_start: 'Get started'
            },
            banner_1: {
                title: 'Exchange your crypto into money',
                subtitle: 'Exchange your cryptos for money and pay with your Wirebit Card ',
                btn: "Create account",
            },
            banner_2: {
                title2: "Manage your cryptocurrencies",
                subtitle2: 'Download Wirebit on the App Store and Google Play',
            },
            banner_3: {
                title3: "Pay with cryptocurrencies, pay with Wirebit!",
                subtitle3: "Pay, buy and withdraw cash worldwide with your Wirebit card.",
                request_card_btn: "Request card",

            },
            banner_4: {
                title4: "Receive payments in crypto for your store and ecommerce",
                thatsit_btn: "Know more",
            },
            banner_5: {
                title5: "Pay your services with cryptocurrencies!",
                subtitle5: "Fast, easy and secure",
                btn_services: "Select service",
            },
            section2:{
                title: 'This card does get to you.',
                subtitle: 'Use your cryptocurrencies in a real way with your Wirebit card and pay with crypto anywhere, anytime.',
                btn_inf: 'More information',
                card_1_title: 'Online shopping',
                card_1_subtitle: 'Lock or unlock your card, check the dynamic CVV, and verify your purchases in real-time from the app.',
                card_2_title: 'Accepted worldwide',
                card_2_subtitle: 'Your Wirebit card is backed by Visa and is accepted at over 30 million merchants worldwide.',
                card_3_title: 'Digital card',
                card_3_subtitle: 'Your purchases are secure with your digital card. Additionally, you can view all your transactions in real-time.'
                
            },
            section3:{
                title: 'Easily handle and manage your cryptocurrencies.',
                card_1_title: 'Wallets',
                card_1_subtitle: 'Create, personally manage, and oversee your portfolios in real-time.',
                card_2_title: 'Exchange',
                card_2_subtitle: 'Convert your cryptocurrencies into real money or another digital assets.',
                card_3_title: 'Receiving and sending.',
                card_3_subtitle: 'Receive and send cryptocurrencies securely through your account.'

            },
            section4:{
                title: 'Take control of you card with mobile app',
                subtitle: 'Download Wirebit on the App Store and Google Play'
            },
            section5:{
                title: 'Transform your mobile\ninto a cryptocurrency terminal.',
                subtitle: "That's it is the first cryptocurrency payment processor for your business, real-time transactions, instant settlement, and free implementation.",
                btn_info: 'Request more information',
                title2: 'Accept crypto, receive money!',
                subtitle2: "That's it converts your crypto payments into real money.",
                btn_register: 'Register now'
            },
            section6:{
                title: 'Accept cryptocurrency payments in your ecommerce.',
                benefit_1_title: 'Free implementation',
                benefit_1_text: 'You can integrate your ecommerce with Wirebit in two ways, through the API or via the mobile app.',
                benefit_2_title: 'Instant settlement',
                benefit_2_text: 'Avoid cryptocurrency volatility and automatically convert payments to fiat currency.',
                benefit_3_title: 'Instant settlement',
                benefit_3_text: 'Access your sales balance within 24 business hours',
                benefit_4_title: 'Bank transfer',
                benefit_4_text: 'Send the final balance of your sales to the bank account linked to your business.',
                benefit_5_title: 'Avoid chargebacks',
                benefit_5_text: 'Avoid chargebacks through secure transactions on the platform.',
                benefit_6_title: 'Personalized attention',
                benefit_6_text: 'We accompany you in your payments! Contact support and chat online when you need it.',
            },
            section7: {
                title: 'The easiest way to enter the world of cryptocurrencies.',
                subtitle: 'Download Wirebit on the App Store and Google Play'
            },
            footer: {
                title1: 'Terms and Conditions',
                title2: 'Privacy Policy',
                title3: 'FAQ',
                esp: 'Spanish',
                eng: 'English',
                disclaimer: 'Wirebit SAPI de CV does not provide any legal, tax, investment or other advice. Please consult a legal/tax/investment professional for questions related to your specific case. Holding digital assets involves high-level risks, and their value can fluctuate considerably on any day. Consequently, your digital asset holdings may be subject to large swings in value and may even lose their entire value.',
                disclaimer_2: 'All rights reserved.'
            }

        },
        LandingCard:{
            navbar: {
                btn_login: 'Log in',
            },
            banner:{
                title: 'Say goodbye to cash and pay with cryptocurrencies',
                subtitle: 'Make it happen with your Wirebit card!',
                request_Card: 'Request my card'
            },
            section2:{
                title: 'Pay with your crypto balance anytime, anywhere',
                card1_title: 'Physical and digital card',
                card1_subtitle: 'Pay and shop at over 30 million merchants or use your digital card for online purchases.',
                card2_title: 'No fees, no conditions',
                card2_subtitle: 'Your Wirebit card has no annual fees, usage commissions, or minimum balances.',
                card3_title: 'Goodbye traditional finance',
                card3_subtitle: 'Stop carrying cash and pay or purchase directly with your cryptocurrency card',
            },
            section3: {
                title: 'Convert your crypto payments into real money.',
                subtitle: 'Applying for your Wirebit card is very simple!',
                text: 'Just follow the next steps',
                btn_signup: 'Sign up',
                step1: '1. Create your account',
                step1_description: 'Create your account via the website or mobile app using your desired email and password.',
                step2: '2. Upload your documents',
                step2_description: 'Complete your account by uploading the requested documents in just 2 steps',
                step3: "3. You're ready!",
                step3_description: 'Request your card, receive it at your address, and start enjoying all the benefits that Wirebit offers you.',
            },
            section4:{
                title: 'This cryptocurrency card does get to you.',
                subtitle: 'Pay with crypto, pay with Wirebit.',
                btn_request_card: 'Request card',
            },
            section5:{
                title: 'Keep control of your card with the mobile app',
                subtitle: 'Download Wirebit on the App Store and Google Play',
            },
            footer: {
                term: 'Terms and Conditions'
            }
        },
        Landing:{
            Navbar:{
                DD_Empresa: 'Company',
                DDI_blog:'Blog',
                DDI_price:'Prices',
                DDI_News:'News',
                Prices:'Prices',
                PandS:'Products and Services',
                LogIn: 'Log In',
                Btn_SignUp:'Join Wirebit!',
                L_spanish:'Spanish',
                L_english:'English',
                nosotros:'About Us',
                servicios:'Services',
                empieza:'Begin',
                comisiones:'Spreads',
                registrate:'Register',
                descarga:'Download',
                tarjeta: 'Card',
                faq: 'FAQ',
            },
            Footer:{
                TermYCon:'Terms and conditions',
                TermYCon2:'Terms & conditions',
                PrivaPly:'Privacy Policy',
                Servi:'Services',
                Pric:'Pricing',
                Conta:'Contact',
                s1_LaR:'License and regulated:',
                s1_W:'WirebitDigital OÜ',
                s1_No:'No. FRK000070 - No.FVR000088',
                s1_Em:'WIREBIT SA DE CV',
                Footer:'Wirebit SAPI de CV provides no legal, tax, investment, or other advice. Please consult your legal/tax/investment professional for questions regarding your specific case. Holding of Digital assets implies high-level risks, and can fluctuate considerably on any given day. Consequently, your digital asset holdings may be subject to large oscillations in value and may even become worthless.',
                Footer_fecha:'All rights reserved - Wirebit'
            },
            Content:{
                s1_note1: 'Everything you and your',
                s1_note2: 'business need to enter the',
                s1_note3: 'world',
                s1_note4:'cryptocurrency',
                Btn_SignUp:'Join Wirebit',
                s2_tabCPL: 'Crypto-Payments online',
                s2_tabCPT: 'Crypto-Payments store',
                s2_tabCPLn1: 'Accept cryptocurrency online',
                s2_tabCPLn2: 'Start accepting cryptocurrency on your website.',
                s2_tabCPLn3: 'Fast integration via API with your e-commerce platform.',
                s2_tabCPTn1: 'Accept cryptocurrency in your store',
                s2_tabCPTn2: 'Connect your Wirebit terminal to start accepting cryptocurrency in your store.',
                s2_tabCPTn3: 'Offer full security to your clients.',
                s3_title: 'Accept payments in major cryptocurrency',
                s3_note1: 'Process payments in mayor cryptocurrency',
                s4_title: 'Why choose Wirebit?',
                s4_note1: 'Instant liquidity, exchange your funds to fiat anytime.',
                s4_note2: 'Receive funds in your bank account anytime you need.',
                s4_note3: '0% transaction fees on incoming payments.',
                s4_note4: 'Tailored solutions to cover your needs.',
                s5_title:'Wirebit Visa',
                s5_subtitle:'Convert your cryptocurrency into cash with our Wirebit Visa.',
                s5_tnote1:'Acceptance',
                s5_note1:'The most widely accepted card worldwide.',
                s5_tnote2:'Cash withdrawal',
                s5_note2:'Instant cash withdrawal from any ATM worldwide.',
                s5_tnote3:'Security',
                s5_note3:'Enjoy the highest security standards within the industry.',
                s6_title:'Download our Wirebit app',
                s6_note:'Manages your cryptocurrency worldwide, with our app.'
            },
            Products:{
                s1_Titulo:'Explore what we offer',
                s1_Text:'We develop products and services to facilitate your entry into the world of cryptocurrencies.',
                s2_Titulo:'Crypto Payments',
                s2_sub1:'Online and Store',
                s2_text1:'Accept cryptos on your website and in your store.',
                s2_sub2:'POS Terminal',
                s2_text2:'Start accepting Cryptocurrency in your store.',
                s2_sub3:'Access to API',
                s2_text3:'Access to an application program interface, connect your e-commerce platform and systems.',
                s2_sub4:'Address / Invoices',
                s2_text4:'Creation of referenced payments, assign destination for a cryptocurrency payment.',
                s3_Titulo:'Exchange & Debit Card',
                s3_sub1:'Fiat Exchange',
                s3_text1:'Exchange your funds to fiat anytime.',
                s3_sub2:'Digital Exchange',
                s3_text2:'Access Online exchange of electronic currencies.',
                s3_sub3:'Debit Card',
                s3_text3:'Convert your Cryptocurrency into cash with our Wirebit Visa.',
                s4_Titulo:'Wallet & Transactions',
                s4_sub1:'Hot Wallet',
                s4_text1:'Online Wallet and connected.',
                s4_sub2:'Cold Wallet',
                s4_text2:'Wallet completely offline, secure store of cryptocurrencies.',
                s4_sub3:'Transactions',
                s4_text3:'Make your Crypto Payments peer to peer.',

            },
            Pricing:{
                Titulo:'Pricing and Fees',
                s1_text:'Pay for what you really use, choose the products and services that cover your needs',

                s2_Titulo:'Pricing',
                s2_Tb_h1:'Products',
                s2_Tb_h2:'Price',

                s2_Tb_r1c1:'Widget',
                s2_Tb_r2c1:'API advance',
                s2_Tb_r3c1:'Debit card issuance',
                s2_Tb_r4c1:'Terminal POS',
                s2_Tb_r5c1:'Referenced payments',
                s2_Tb_r6c1:'Customized QR code issuance',
                s2_Tb_r7c1:'QR code',


                s2_Tb_r1c2:'Coming soon',
                s2_Tb_r2c2:'499 US$ monthly',
                s2_Tb_r3c2:'15 US$',
                s2_Tb_r4c2:'Contact us',
                s2_Tb_r5c2:'0 US$',
                s2_Tb_r6c2:'30 US$',
                s2_Tb_r7c2:'0 US$',


                s3_Titulo:'Fees',
                s3_Tb_h1:'Operation',
                s3_Tb_h2:'Fees',

                s3_Tb_r1c1:'Incoming cryptopayments',
                s3_Tb_r2c1:'Transfers Wirebit - Wirebit',
                s3_Tb_r3c1:'Withdraw',
                s3_Tb_r4c1:'Virtual exchange',
                s3_Tb_r5c1:'Fund card',
                s3_Tb_r6c1:'FIAT deposits in Wirebit account ',
                s3_Tb_r7c1:'Bank Transfer',

                s3_Tb_r1c2:'0%',
                s3_Tb_r2c2:'0%',
                s3_Tb_r3c2:'1%',
                s3_Tb_r4c2:'1%',
                s3_Tb_r5c2:'2%',
                s3_Tb_r6c2:'3%',
                s3_Tb_r7c2:'México 0% / International 45 US$',
            },
            faq:{
                s1_titulo:'Wirebit Visa, your key to the future of finance.',

                s2_titulo:'Your Cryptos, your finances, your card.',
                s2_description: 'Your Wirebit Visa debit card allows you to use your cryptos whenever and wherever you want in a fast and easy way.',
                s2_fact1_1:'+1 million',
                s2_fact1_2:'Accepted merchants',
                s2_fact1_3:'The largest affiliated network gives you the freedom to trade worldwide.',
                s2_fact2_1:'Total control',
                s2_fact2_2:'From your mobile application',
                s2_fact2_3:'Activate, reload and control your card movements from the palm of your hand with your wirebit app.',
                s2_fact3_1:'Complete security',
                s2_fact3_2:'Anytime, anywhere',
                s2_fact3_3:'Secure transactions and data management backed by the highest security standards in the industry.',

                s3_titulo:'What makes Wirebit Visa so special,',
                s3_opc1:'A real solution at your fingertips',
                s3_opc2:'Instant cash withdrawal from any ATM in the world',
                s3_opc3:'Fast and easy use of your cryptocurrencies',

                s4_titulo: 'You feel secure 24/7',
                s4_opc1_1:'Real-time information',
                s4_opc1_2:'Access to your transaction log instantly from your app.',
                s4_opc2_1:'Block instantly',
                s4_opc2_2:'Block your card whenever you want from your app or account.',
                s4_opc3_1:'Customer service',
                s4_opc3_2:'It has a team trained to give you the best experience.',

                s5_titulo:'Doubts? We solve them',
                s5_q1_q:'Where can the Wirebit card be used?',
                s5_q1_a:'Your Wirebit card is accepted at over one million Visa affiliated merchants worldwide.',
                s5_q2_q:'How long does it take for my card to arrive?',
                s5_q2_a:'Your card will be in your hands in no more than 4 weeks after you pay for it.',
                s5_q3_q:'What is the cost of the card?',
                s5_q3_a:'The Wirebit Card has an issuance and shipping cost of US$15 for customers within Mexico and US$50 for international customers.',
                s5_q4_q:'What do I do if I do not remember my PIN?',
                s5_q4_a:'In case you lose your PIN, log in to your wirebit account in the card section and follow the recovery procedure.',
                s5_q5_q:'In case you lose your card:',
                s5_q5_a:'Log in to the card section of your wirebit account, block your card, write an email to hello@wirebit.com informing us of the loss and requesting a replacement.',
                s5_q6_q:'Can I deposit to my Wirebit Visa debit card?',
                s5_q6_a:'No, your Wirebit Visa debit card can only receive deposits made from your account.',
                s5_q7_q:'Why does my debit card show its balance in Mexican Pesos?',
                s5_q7_a:'Wirebit is a proudly Mexican company, however our reach is worldwide and you will be able to enjoy your card anywhere in the world.',
                s5_q8_q:'Can I make cash withdrawals with my Wirebit Visa?',
                s5_q8_a:'Yes, you can withdraw cash from any ATM that processes Visa cards, this type of transaction may incur fees charged by the ATMs.',

                s6_titulo:'Download Wirebit App',
                s6_subtitulo:'Manage at all times all your payments in cryptocurrencies, credit and debit card.'
            }

        },
        landing3:{
            boton:'Join Wirebit!',
            hipervinculo:'I want to affiliate my business',
            hipervinculo2:'FAQS',
            hipervinculo3:'I want to take my business to the next level',
            menu:{
                nosotros:'Nosotros',
                servicios:'Servicios',
                empieza:'Empieza',
                comisiones:'Comisiones',
                registrate:'Registrate',
                descarga:'Descarga',
                iniciar:'Iniciar Sesión',
            },
            banner:{
                titulo:'Take your business to the next level.',
                subtitulo:'Accept payments with crypto.',
                subtitulo2:'Receive payments in your e-commerce with crypto, credit card and debit card. With Wirebit everything is possible!',
                button1:"Join Wirebit!",
                button2:"Request it now!",
                api:{
                    titulo:'Manage your business online',
                    subtitulo:"Our API allows you to receive payments with cryptocurrencies, credit and debit card by connecting in a simple way with your business.",
                },
                tarjeta:{
                    titulo:'The first cryptocard in LATAM',
                    subtitulo:'The Wirebit card allows you to use your cryptos in a simple way. Make payments or withdraw from any ATM.',
                },
                thatsit:{
                    titulo:'Do you already know',
                    subtitulo:'Enjoy the new Wirebit service. Turn any mobile device into a terminal and start receiving payments with cryptocurrencies in your business or online store.',
                },
                servicio:{
                    titulo:'Manage your business online',
                    subtitulo1:"Don't think twice and pay for your services with Wirebit.",
                    subtitulo2:"Enter the app and go to the transfer section to pay for your services.",
                }
            },
            secion2:{
                titulo:'The best services in receiving payments.',
                subtitulo:'We have the necessary technological tools for growing your business and the best personalized spreads for you.',
                cripto:'Crypto Payments',
                criptoDesc:'Receive crypto-payments in your online store.  Quick integration via API with your e-commerce.',
                credito:'Credit Card Payments',
                creditoDesc:'Receive payments with credit card on your online store. Find out the personalized spreads for you!',
                debito:'Debit Card Payments',
                debitoDesc:'Receive payments with credit card on your online store. Find out the personalized spreads for you!',
            },
            seccion3:{
                titulo:'Wirebit’s crypto card',
                subtitulo:'The only one in LATAM to pay with crypto wherever you want.',
                boton:'Request it now!',
                paga:'Pay with crypto',
                padaGesc:'Make online or physical payments in any point of sale.',
                retira:'Withdraw with crypto',
                retiraDesc:'Access to your balance in any ATM of the world.',
                acepta:'Card acceptance',
                aceptaDesc:'Accepted in more than 20 million establishments.',
                seguridad:'Security',
                seguridadDesc:'Enjoy the highest security standards that Visa offer.',
            },
            seccion4:{
                titulo:'Everything you’re searching for growing your e-commerce',
                subtitulo:'We incorporate technological and financial functions for your e-commerce expansion.',
                facilita:"Make your client's life easier",
                facilitaDesc:'We provide the necessary technology to facilitate your payment.',
                recepcion:'Reception of crypto payments',
                recepcionDesc:'Receive payments with the most important cryptos.',
                comisiones:'Personalized spreads',
                comisionesDesc:'The spreads are personalized, choose the best one for your e-commerce.',
                tipoCuentas:'Type of accounts',
                tipoCuentasDesc:'Your needs are different, so is your type of account.',
                estandares:'Security standards',
                // estandaresDesc:'Security of data standard for the Payment Card Industry with PCI DSS.',
                estandaresDesc:'Data security standard.',
                empresa:'100% mexican business',
                empresaDesc:'We speak your same language. Customer support chat in spanish 24/7',
            },
            seccion5:{
                titulo:'',
                subtitulo:'Without rents and fixed minimums!',
                bannerTitulo:'Commissions from',
                // bannerPorcentaje:'2.5% + IVA',
                bannerPorcentaje:'1%',
                bannerComision:'+ $2 Pesos por transacción.',
                bannerDesc:'You only pay a commission for each payment you make.',
                bannerPersonaFisica: 'Physical Person',
                bannerPersonaMoral: 'Moral Person',
                feeVirtual: 'Fee for virtual exchange',
                feeCripto: 'Crypto withdrawal fee',
                feeBanco: 'Fee for bank withdrawals',
                feeRetiro: 'Card withdrawal fee',
                comision1: '1% Per operation',
                comision2: '2% Per operation',
                titleCrypto: 'Crypto transactions',
                subtituloCrypto: 'Clear commissions.',
                subtituloCrypto2: 'For Physical Person and Moral Person.',
            },
            seccion6:{
                titulo:'How to start recieving payments with crypto?',
                subtitulo:'We incorporate technological and financial functions for your e-commerce expansion.',
                ingresa:'1. Enter your request',
                ingresaDesc:'Register and upload all the documentation needed.',
                respuesta:'2. Response to your request',
                respuestaDesc:'Our compliance department will give an answer in 48 hours.',
                bienvenido:'3. Welcome to Wirebit!',
                bienvenidoDesc:'You’ll receive a welcome email. If you have any doubt, contact us.',
            },
            seccion7:{
                titulo:'Download Wirebit App!',
                subtitulo:'Manage your crypto payments any time.',
            },
            seccion8:{
                titulo:'What you’re looking for your e-commerce',
                subtitulo:'With Wirebit, everything is possible, receive and manage your payments through crypto, credit card and debit card.',
                comercio:'I want to affiliate my business and online store to Wirebit',
                comercioDesc:'Bring out the full potential of your e-commerce in 3 steps.',
                criptopagos:'I want to receive crypto payments in my e-commerce',
                criptopagosDesc:'Innovate within your industry and reach out new clients.',
            },
            footer:{
                contactanos:'Contact us',
                texto1:'Whatsapp or Email',
                texto2:'Monday to Friday from 9:00 am to 6:00 pm,',
                texto3:'central Mexico time.',
                acerca:'About',
                privacidad:'Privacy Notice',
                terminosCondiciones:'Terms & conditions',
            },
        },
        faqs:{
            title:'Frequently Asked Questions.',
            faqBtn1:'Wirebit',
            faqBtn2:'My Account',
            faqBtn3:'Balances and Charges',
            faqBtn4:'Terms',
            section1:{
                title:'About Wirebit',
                S1faq1:'What is Wirebit Digital?',
                S1faq1Ans:'It’s a digital platform that provides tools for the processing of payments in cryptocurrencies, administration and use of them in an easy way. It allows its clients to enter the new world of digital finance.',
                S1faq2:'What is a cryptocurrency payment processor?',
                S1faq2Ans:'It is a company responsible for managing the flow of transactions between sellers and buyers, providing technological and financial tools to facilitate the use of this new financial asset with unlimited potential.',
                S1faq3:'What products does Wirebit offer?',
                S1faq3Ans:'- Payment processor for e-commerce connected via API.',
                S1faq3Ans2:'- Digital wallet services (hot and cold wallets).',
                S1faq3Ans3:'- Crypto card accepted in more than 20 million establishments in the world.',
                S1faq3Ans4:'- Wirebit app, access to your account and control of your assets 24/7.',
                S1faq4:'Which cryptos can I process?',
                S1faq4Ans:'The main ones in the market',
                S1faq4Ans2:'Bitcoin, Litecoin, Ethereum, Dash, XRP, USDT Tether via Solana network',
                S1faq5:'How do I protect myself from cryptocurrency volatility?',
                S1faq5Ans:'Wirebit has the tools to minimize this risk as much as possible and prevent loss of value for our users.',
            },
            section2:{
                title:'Deposits, balances and fees.',
                S2faq1:'How long does it take for the money deposited in my account to be reflected?',
                S2faq1Ans:'The operation would take between 24 and 48 hours in being reflected once the request is made.',
                S2faq2:'Are my received payments kept as cryptocurrencies or converted to money?',
                S2faq2Ans:'Wirebit can store in cryptocurrencies or convert them into legal tender according to the decision of our users.',
                S2faq3:'How much do I get charged for receiving payments in cryptocurrencies?',
                S2faq3Ans:'0%, receive payments in crypto without any commission cost.',
                S2faq4:'Can I issue invoices?',
                S2faq4Ans:'It’s not possible.',
                S2faq5:'Is there a sales limit with Wirebit?',
                S2faq5Ans:"There doesn't exist a sales limit.",
            },
            section3:{
                title:'About my account.',
                S3faq1:'The account has any cost?',
                S3faq1Ans:'No, it’s totally free.',
                S3faq2:'Is there a maintenance cost for my Wirebit account?',
                S3faq2Ans:'There is no cost for maintenance.',
                S3faq3:'From which country can I open my account?',
                S3faq3Ans:'From most countries.',
                S3faq4:'Does the card have a cost?',
                S3faq4Ans:'The Wirebit Card has an issuance and shipping cost of $15 dollars for clients within the Mexican territory and $50 dollars for international clients.',
                S3faq5:'Can I make cash withdrawals with my Wirebit Card?',
                S3faq5Ans:'Yes, you can withdraw money in cash from any ATM that processes Visa cards, but this type of operations may lead to the collection of commissions by the ATM’s',
                S3faq6:'What documents are required to open an account?',
                S3faq6Ans:'Basic personal documentation such as identification, proof of address, tax identification of your country (for some services), etc.',
            },
            section4:{
                title:'Terms & Conditions',
                S4faq1:'Where can I read the terms and conditions?',
                S4faq1Ans:'To read our terms and conditions you can enter the following link:',
                S4faq1Terms:'See terms and conditions',
                S4faq2:'Where can I read the privacy notice?',
                S4faq2Ans:'To read our privacy notice you can enter the following link:',
                S4faq2Terms:'Read privacy notice',
            },
        },
    },
    es:{
        LandingRedesign: {
            navbar: {
                btn_card: 'Conoce la tarjeta Wirebit',
                btn_login: 'Iniciar sesión',
                btn_start: 'Comenzar'
            },
            banner_1: {
                title: 'Convierte tus pagos en cripto a dinero real',
                subtitle: 'Cambia tus criptomonedas por dinero real y paga con tu tarjeta Wirebit.',
                btn: "Crear cuenta",
            },
            banner_2: {
                title2: 'Administra personalmente\ntus criptomonedas',
                subtitle2: 'Descarga Wirebit en App Store y Google Play',
            },
            banner_3: {
                title3: "Paga con criptos, paga\ncon Wirebit",
                subtitle3: "Paga, compra y retira efectivo en todo el mundo\ncon tu tarjeta Wirebit.",
                request_card_btn: "Solicitar mi tarjeta"

            },
            banner_4: {
                title4: "Recibe pagos en cripto para tu comercio físico y online",
                thatsit_btn: "Conocer más",
            },
            banner_5: {
                title5: "¡Paga tus servicios con criptomonedas!",
                subtitle5: "Rápido, fácil y seguro",
                btn_services: "Elegir servicio"
            },
            section2:{
                title: 'Esta tarjeta sí te llega',
                subtitle: 'Usa tus criptomonedas de una manera real con tu tarjeta wirebit y paga con criptos donde quieras, cuando quieras.',
                btn_inf: 'Más información',
                card_1_title: 'Compras en línea',
                card_1_subtitle: 'Bloquea o desbloquea tu tarjeta, consulta el CVV dinámico y verifica tus compras en tiempo real desde la app.',
                card_2_title: 'Aceptada mundialmente',
                card_2_subtitle: 'Tu tarjeta Wirebit está respaldada por Visa, es aceptada en más de 30 millones de comercios en todo el mundo.',
                card_3_title: 'Tarjeta digital',
                card_3_subtitle: 'Tus compras están seguras con tu Tarjeta digital. Además visualiza en tiempo real todas tus transacciones.'
            },
            section3:{
                title: 'Administra y gestiona tus criptomonedas fácilmente',
                card_1_title: 'Carteras',
                card_1_subtitle: 'Crea, administra y gestiona personalmente tus carteras en tiempo real.',
                card_2_title: 'Intercambia',
                card_2_subtitle: 'Convierte tus criptomonedas por otros activos virtuales o por dinero convencional.',
                card_3_title: 'Recepción y envío',
                card_3_subtitle: 'Recibe, envía y administra tus criptomonedas sin fronteras y sin horarios, tus finanzas en tiempo real.'
            },
            section4:{
                title: 'Mantén el control de tu tarjeta con la app móvil',
                subtitle: 'Descarga Wirebit en App Store y Google Play'
            },
            section5:{
                title: 'Convierte tu celular\nen una terminal de criptos',
                subtitle: 'That’s it es el primer procesador de pagos en criptomonedas para tu comercio, transacción en tiempo real, compensación Inmediata e implementación gratis.',
                btn_info: 'Solicitar más información',
                title2: '¡Acepta cripto, recibe dinero!',
                subtitle2: 'That’s it convierte tus pagos en cripto a dinero real.',
                btn_register: 'Quiero registrarme'
            },
            section6:{
                title: 'Acepta pagos con criptomonedas en tu comercio electrónico.',
                benefit_1_title: 'Implementación gratuita',
                benefit_1_text: 'Puedes integrar tu ecommerce a Wirebit de dos maneras, mediante la API o a través de la aplicación móvil.',
                benefit_2_title: 'Compensación instantánea',
                benefit_2_text: 'Evita la volatilidad de la criptomoneda y convierte en automático los pagos a dinero fiat.',
                benefit_3_title: 'Tus ventas en 24 horas',
                benefit_3_text: 'Accede al balance de tus ventas en 24 horas hábiles.',
                benefit_4_title: 'Transferencia bancaria',
                benefit_4_text: 'Envía el balance final de tus ventas hacia la cuenta bancaria ligada a tu comercio.',
                benefit_5_title: 'Evita contracargos',
                benefit_5_text: 'Evita contracargos mediante las transacciones seguras en la plataforma.',
                benefit_6_title: 'Atención personalizada',
                benefit_6_text: '¡Te acompañamos en tus pagos! Comunícate al soporte y chat online cuando lo necesites.',
            },
            section7: {
                title: 'La manera más sencilla de entrar al mundo de las cripto',
                subtitle: 'Descarga Wirebit en App Store y Google Play'
            },
            footer: {
                title1: 'Términos y condiciones',
                title2: 'Politica de Privacidad',
                title3: 'Preguntas frecuentes',
                esp: 'Español',
                eng: 'Ingles',
                disclaimer: 'Wirebit SAPI de CV no proporciona ningún tipo de asesoramiento legal, fiscal, de inversión o de otro tipo. Por favor, consulte a un profesional legal/fiscal/ o de inversiones para preguntas relacionadas con su caso específico. La tenencia de activos digitales implica riesgos de alto nivel, y su valor puede fluctuar considerablemente en cualquier día. En consecuencia, su tenencia de activos digitales puede estar sujeta a grandes oscilaciones de valor e incluso puede perder su valor por completo.',
                disclaimer_2: 'Todos los derechos reservados'
            },

        },
        LandingCard:{
            navbar: {
                btn_login: 'Iniciar sesión',
            },
            banner:{
                title: 'Dile adiós al efectivo y paga con criptomonedas',
                subtitle: '¡Hazlo realidad con tu tarjeta Wirebit!',
                request_Card: 'Solicitar mi tarjeta'
            },
            section2:{
                title: 'Paga con el balance de tus criptos cuando quieras, donde quieras.',
                card1_title: 'Tarjeta física y digital',
                card1_subtitle: 'Paga y compra en más de 30 millones de comercios o usa tu tarjeta digital para realizar compras en línea.',
                card2_title: 'Sin cargos, ni condiciones',
                card2_subtitle: 'Tu tarjeta Wirebit no tiene cargos por anualidad, comisiones de uso o balances mínimos.',
                card3_title: 'Adiós finanzas tradicionales',
                card3_subtitle: 'Deja de cargar con efectivo y paga o compra directamente con tu tarjeta de criptomonedas.',
            },
            section3:{
                title: 'Convierte tus pagos en cripto a dinero real',
                subtitle: '¡Solicitar tu tarjeta Wirebit es muy sencillo!',
                text: 'Solo sigue los siguientes pasos',
                btn_signup: 'Crear una cuenta',
                step1: '1. Create tu cuenta',
                step1_description: 'Desde Web o aplicación móvil crea tu cuenta con tu correo electrónico y contraseña que deseas.',
                step2: '2. Sube tus documentos',
                step2_description: 'Completa tu cuenta subiendo los documentos solicitados en tan solo 2 pasos.',
                step3: '3. ¡Estás listo!',
                step3_description: 'Solicita tu tarjeta, recíbela en tu domicilio y comienza a disfrutar todos los beneficios que Wirebit te ofrece.',
                
            },
            section4:{
                title: 'Esta tarjeta de criptomonedas sí te llega',
                subtitle: 'Paga con criptos, paga con Wirebit.',
                btn_request_card: 'Solicitar tarjeta',
            },
            section5:{
                title: 'Mantén el control de tu tarjeta con la app móvil',
                subtitle: 'Descarga Wirebit en App Store y Google Play',
            }
        },
        Landing:{
            Navbar:{
                DD_Empresa: 'Empresa',
                DDI_blog:'Blog',
                DDI_price:'Precios',
                DDI_News:'Noticias',
                Prices:'Precios',
                PandS:'Productos y Servicios',
                LogIn: 'Iniciar Sesión',
                Btn_SignUp:'¡Únete a Wirebit!',
                L_spanish:'Español',
                L_english:'Inglés',
                nosotros:'Nosotros',
                servicios:'Servicios',
                empieza:'Empieza',
                comisiones:'Comisiones',
                registrate:'Registrate',
                descarga:'Descarga',
                tarjeta: 'Tarjeta',
                faq: 'Preguntas frecuentes',
            },
            Footer:{
                TermYCon:'Terminos y condiciones',
                TermYCon2:'Terminos y condiciones',
                PrivaPly:'Politica de privacidad',
                Servi:'Servicios',
                Pric:'Precios',
                Conta:'Contactanos',
                s1_LaR:'Bajo Licencia y regulado:',
                s1_W:'WirebitDigital OÜ',
                s1_No:'No. FRK000070 - No.FVR000088',
                s1_Em:'WIREBIT SA DE CV',
                Footer:'Wirebit SAPI de CV no proporciona ningún tipo de asesoramiento legal, fiscal, de inversión o de otro tipo. Por favor, consulte a un profesional legal/fiscal/ o de inversiones para preguntas relacionadas con su caso específico. La tenencia de activos digitales implica riesgos de alto nivel, y su valor puede fluctuar considerablemente en cualquier día. En consecuencia, su tenencia de activos digitales puede estar sujeta a grandes oscilaciones de valor e incluso puede perder su valor por completo.',
                Footer_fecha:'Todos los derechos reservados - Wirebit'
            },
            Content:{
                s1_note1:'Todo lo que tú y tu negocio',
                s1_note2:'necesitan para ingresar al',
                s1_note3:'mundo de las',
                s1_note4:'criptomonedas',
                Btn_SignUp:'Únete a Wirebit',
                s2_tabCPL:'Cripto-Pagos en línea',
                s2_tabCPT:'Cripto-Pagos en tiendas',
                s2_tabCPLn1:'Acepta criptomonedas en línea',
                s2_tabCPLn2:'Empieza a aceptar criptomonedas en tu página web.',
                s2_tabCPLn3:'Integración rápida vía API con tu plataforma e-commerce.',
                s2_tabCPTn1:'Acepta criptomonedas en tu tienda',
                s2_tabCPTn2:'Conecta tu terminal Wirebit para empezar a aceptar criptomonedas en tu tienda.',
                s2_tabCPTn3:'Ofrece total seguridad a tus clientes.',
                s3_title:'Acepta pagos en las principales criptomonedas',
                s3_note1:'Procesa pagos en las principales criptomonedas',
                s4_title:'¿Por qué Wirebit?',
                s4_note1:'Liquidez instantánea, cambia tus fondos a FIAT en cualquier momento.',
                s4_note2:'Recibe fondos en tu cuenta bancaria en el momento que lo necesites.',
                s4_note3:'0% de comisión en transacciones de pagos.',
                s4_note4:'Herramientas a la medida de tus necesidades.',
                s5_title:'Tarjeta Wirebit Visa',
                s5_subtitle:'Convierte tus criptomonedas en efectivo con nuestra tarjeta Wirebit Visa.',
                s5_tnote1:'Disponibilidad',
                s5_note1:'La tarjeta más aceptada a nivel mundial.',
                s5_tnote2:'Retiro en efectivo',
                s5_note2:'Retira efectivo desde cualquier ATM en el mundo.',
                s5_tnote3:'Seguridad',
                s5_note3:'Disfruta de los más altos estándares seguridad de la industria.',
                s6_title:'Descarga nuestra Wirebit app',
                s6_note:'Administra tus criptomonedas desde cualquier parte del mundo, con nuestra app.'
            },
            Products:{
                s1_Titulo:'Conoce lo que ofrecemos',
                s1_Text:'Desarrollamos productos y servicios para facilitar tu entrada en el mundo de las criptomonedas.',
                s2_Titulo:'Criptopagos',
                s2_sub1:'En línea y en Tiendas',
                s2_text1:'Acepta criptomonedas en tu página web y en tu tienda.',
                s2_sub2:'Terminal punto de venta',
                s2_text2:'Empieza a aceptar criptomonedas en tu tienda.',
                s2_sub3:'Acceso a la  API',
                s2_text3:'Acceso a una interfaz de programación de aplicaciones. Conecta tu plataforma de comercio electrónico y otros sistemas.',
                s2_sub4:'Direcciones',
                s2_text4:'Creación de pagos referenciados, asigna un destino para cada pago en criptomonedas.',
                s3_Titulo:'Cambio y tarjeta de débito',
                s3_sub1:'Cambio a moneda FIAT',
                s3_text1:'Cambia tus fondos a moneda FIAT en cualquier momento.',
                s3_sub2:'Cambio digital',
                s3_text2:'Acceso a plataforma de cambio en línea de monedas electrónicas.',
                s3_sub3:'Tarjeta de débito',
                s3_text3:'Convierte tus criptomonedas en efectivo con nuestra tarjeta Wirebit Visa.',
                s4_Titulo:'Wallets y Transacciones',
                s4_sub1:'Hot Wallet',
                s4_text1:'Cartera en línea y conectada.',
                s4_sub2:'Cold Wallet',
                s4_text2:'Cartera completamente offline, almacenamiento seguro de tus criptomonedas.',
                s4_sub3:'Transacciones',
                s4_text3:'Realiza tus pagos en criptomonedas.',
            },
            Pricing:{
                Titulo:'Precios y Comisiones',
                s1_text:'Paga por lo que verdaderamente usas, elige los productos y servicios cumplen con tus necesidades.',

                s2_Titulo:'Precios',
                s2_Tb_h1:'Producto',
                s2_Tb_h2:'Precio',

                s2_Tb_r1c1:'Widget',
                s2_Tb_r2c1:'API avanzada',
                s2_Tb_r3c1:'Emisión de tarjeta débito',
                s2_Tb_r4c1:'Terminal PDV',
                s2_Tb_r5c1:'Pagos referenciados',
                s2_Tb_r6c1:'Emisión de código QR personalizado',
                s2_Tb_r7c1:'Código QR',


                s2_Tb_r1c2:'Próximamente',
                s2_Tb_r2c2:'499 US$ mensuales',
                s2_Tb_r3c2:'15 US$',
                s2_Tb_r4c2:'Contáctanos',
                s2_Tb_r5c2:'0 US$',
                s2_Tb_r6c2:'30 US$',
                s2_Tb_r7c2:'0 US$',


                s3_Titulo:'Comisiones',
                s3_Tb_h1:'Operaciones',
                s3_Tb_h2:'Comisión',

                s3_Tb_r1c1:'Recepción de criptopagos',
                s3_Tb_r2c1:'Transferencia Wirebit - Wirebit',
                s3_Tb_r3c1:'Retiro',
                s3_Tb_r4c1:'Virtual exchange',
                s3_Tb_r5c1:'Depósito en tarjeta ',
                s3_Tb_r6c1:'Depósito FIAT en cuenta Wirebit',
                s3_Tb_r7c1:'Transferencia de banco internacional',


                s3_Tb_r1c2:'0%',
                s3_Tb_r2c2:'0%',
                s3_Tb_r3c2:'1%',
                s3_Tb_r4c2:'1%',
                s3_Tb_r5c2:'2%',
                s3_Tb_r6c2:'3%',
                s3_Tb_r7c2:'México 0% / Internacional 45 US$',
            },
            faq:{
                s1_titulo:'Wirebit Visa, tu llave al futuro de las finanzas.',

                s2_titulo:'Tus Criptos, tus finanzas, tu tarjeta.',
                s2_description: 'Tu tarjeta de debito Wirebit Visa te permite usar tus criptos cuando y donde quieras de una manera rápida y sencilla.',
                s2_fact1_1:'+1 millon',
                s2_fact1_2:'Establecimientos aceptados',
                s2_fact1_3:'Las más amplia red afiliada te dara la libertad de realizar operaciones a nivel mundial.',
                s2_fact2_1:'Control total',
                s2_fact2_2:'Desde tu aplicación Móvil',
                s2_fact2_3:'Activa, recarga y  Controla tus movimientos de tu tarjeta desde la palma de tu mano con tu app de wirebit.',
                s2_fact3_1:'Seguridad Completa',
                s2_fact3_2:'Cuando sea y donde sea',
                s2_fact3_3:'Seguridad en tus operaciones y en el manejo de tu informacion respaldada por los mas altos estándares de seguridad de la industria.',

                s3_titulo:'Que hace tan especial a la tarjeta Visa Wirebit,',
                s3_opc1:'Una herramienta real al alcance de tu mano',
                s3_opc2:'Retiro instantáneo de efectivo desde cualquier ATM en el mundo',
                s3_opc3:'Uso de tus criptomonedas rapido y sencillo',

                s4_titulo: 'Tú siéntete seguro 24/7',
                s4_opc1_1:'Información en tiempo real',
                s4_opc1_2:'Acceso al registro de tus transacciones registradas al momento desde tu app.',
                s4_opc2_1:'Bloquea al Instante',
                s4_opc2_2:'Bloquea tu tarjeta en el momento que desees desde tu aplicación o cuenta.',
                s4_opc3_1:'Atención al cliente',
                s4_opc3_2:'Cuenta con un equipo formado para darte la mejor experiencia.',

                s5_titulo:'¿Dudas? Te las resolvemos',
                s5_q1_q:'¿Dónde puede ser usada la tarjeta Wirebit?',
                s5_q1_a:'Tu tarjeta Wirebit es aceptada en los más de un millón de comercios afiliados a Visa a nivel mundial.',
                s5_q2_q:'¿Cuánto tiempo tarda mi tarjeta en llegar?',
                s5_q2_a:'Tu tarjeta estará en tus manos en un lapso no mayor de 4 semanas contadas a partir a la realización del pago de la misma.',
                s5_q3_q:'¿Cuál es el costo de la tarjeta?',
                s5_q3_a:'La Tarjeta Wirebit tienen un costo de emisión  y envío de 15 dólares para clientes dentro del territorio Mexicano y 50 dólares para clientes internacionales.',
                s5_q4_q:'¿Qué hago si no recuerdo mi NIP?',
                s5_q4_a:'En caso de extravío de tu NIP, ingresa a tu cuenta wirebit en la sección de tarjetas y realiza el procedimiento de recuperación.',
                s5_q5_q:'En caso de perdida de tu tarjeta:',
                s5_q5_a:`Ingresa en la sección de tarjeta de tu cuenta Wirebit, realiza el bloqueo de la misma, escribe un correo electrónico a hello@wirebit.com informándonos de la perdida y solicitando la reposición.`,
                s5_q6_q:'¿Puedo depositar en mi tarjeta de débito Wirebit Visa?',
                s5_q6_a:'No, tu tarjeta de débito Wirebit Visa solo puede recibir depósitos realizados desde tu cuenta.',
                s5_q7_q:'¿Por qué mi tarjeta de débito muestra su balance en pesos mexicanos?',
                s5_q7_a:'Wirebit es una empresa orgullosamente mexicana, sin embargo nuestro alcance es mundial y podrás disfrutar de tu tarjeta en cualquier parte del mundo.',
                s5_q8_q:'¿Puedo realizar retiros en efectivo con mi Wirebit Visa?',
                s5_q8_a:'Sí, puedes retirar dinero en efectivo desde cualquier ATM que procese tarjetas Visa, en este tipo de operaciones pueden acarrear cobro de comisiones por parte de los ATM.',

                s6_titulo:'¡Descarga Wirebit App!',
                s6_subtitulo:'Administra en todo momento todos tus pagos en criptomonedas, tarjeta de crédito y débito.'
            }
        },
        landing3:{
            boton:'¡Únete a Wirebit!',
            hipervinculo:'Quiero afiliar mi negocio',
            hipervinculo2:'Preguntas Frecuentes',
            hipervinculo3:'Quiero afiliar mi negocio',
            menu:{
                nosotros:'Nosotros',
                servicios:'Servicios',
                empieza:'Empieza',
                comisiones:'Comisiones',
                registrate:'Registrate',
                descarga:'Descarga',
                iniciar:'Iniciar Sesión',
            },
            banner:{
                titulo:'¡Todo es posible!',
                subtitulo:'El primer procesador de pagos en México de cripto.',
                button1:"¡Únete a Wirebit!",
                button2:"Solicita tu tarjeta",
                api:{
                    titulo:'Administra tu comercio en línea',
                    subtitulo:'Nuestro API te permite recibir pagos con criptomonedas, tarjeta de crédito y débito al conectarse de una manera sencilla con tu comercio.',
                },
                tarjeta:{
                    titulo:'La primera criptotarjeta en LATAM',
                    subtitulo:'La tarjeta Wirebit te permite usar tus criptos de una manera sencilla. Realiza pagos o retira desde cualquier cajero automático.',
                },
                thatsit:{
                    titulo:'¿Ya conoces',
                    subtitulo:'Disfruta del nuevo servicio de Wirebit. Convierte cualquier dispositivo móvil en una terminal y empieza a recibir pagos con criptomonedas en tu comercio o tienda en línea.',
                },
                servicio:{
                    titulo:'¡Paga tus servicios con criptomonedas!',
                    subtitulo1:'No des más vueltas y paga tus servicios con Wirebit.',
                    subtitulo2:'Entra a la app y ve al apartado de transferencias para pagar tu servicios.'
                }
            },
            secion2:{
                titulo:'Los mejores servicios en recepción de pagos.',
                subtitulo:'Tenemos las herramientas tecnológicas necesarias para crecer tu negocio y las mejores comisiones personalizadas para ti.',
                cripto:'Criptopagos',
                criptoDesc:'Recibe pagos con criptomonedas en tu tienda en línea. Rápida integración vía API con tu e-commerce.',
                credito:'Pagos con tarjeta de crédito',
                creditoDesc:'¡Recibe pagos con tarjeta de crédito en tu tienda en línea. ¡Descubre las comisiones personalizadas para ti!',
                debito:'Pagos con tarjeta de débito',
                debitoDesc:'¡Recibe pagos con tarjeta de débito en tu tienda en línea. ¡Descubre las comisiones personalizadas para ti!',
            },
            seccion3:{
                titulo:'La tarjeta del futuro.',
                subtitulo:'La única en Latinoamérica para pagar con criptomonedas.',
                boton:'¡Solicítala ya!',
                paga:'Paga con Criptos',
                padaGesc:'Realiza pagos en línea o físicos en cualquier punto de venta.',
                retira:'Retira con Criptos',
                retiraDesc:'Dispón de tu balance desde cualquier',
                retiraDesc1:'ATM en el mundo.',
                acepta:'Aceptación de tarjeta',
                aceptaDesc:'Aceptada en más de 20 millones de establecimientos.',
                seguridad:'Seguridad',
                seguridadDesc:'Disfruta de los altos estándares de seguridad que ofrece Visa.',
            },
            seccion4:{
                titulo:'Todo lo que buscas para tu e-commerce',
                subtitulo:'Incorporamos funciones tecnológicas y financieras para la',
                subtitulo1: 'expansión de tu e-commerce.',
                facilita:'Facilita la vida de tus clientes',
                facilitaDesc:'Brindamos la tecnología necesaria para facilitar el pago de los usuarios.',
                recepcion:'Recepción de criptopagos',
                recepcionDesc:'Recibe pagos con las principales criptomonedas.',
                comisiones:'Comisiones personalizadas',
                comisionesDesc:'Las comisiones son personalizadas, elige la mejor para tu e-commerce.',
                tipoCuentas:'Tipos de cuentas',
                tipoCuentasDesc:'Tus necesidades son diferentes y tu tipo de cuenta también lo es.',
                estandares:'Estándares de seguridad',
                // estandaresDesc:'Estándar de Seguridad de Datos para la Industria de Tarjeta de Pago con PCI DSS.',
                estandaresDesc:'Estándar de seguridad de datos.',
                empresa:'Empresa 100% mexicana',
                empresaDesc:'¡Hablamos tu mismo idioma! Soporte y chat online en español 24/7',
            },
            seccion5:{
                titulo:'',
                subtitulo: 'Comisiones personalizadas para ti.',
                subtitulo2:'¡Sin rentas y sin mínimos fijos!',
                bannerTitulo:'Comisión única desde',
                bannerPorcentaje:'1%',
                bannerComision:'+ $2 Pesos por transacción.',
                bannerDesc:'Solo pagas una comisión por cada transacción que realices.',
                bannerPersonaFisica: 'Persona Física',
                bannerPersonaMoral: 'Persona Moral',
                feeVirtual: 'Comisión por virtual exchange',
                feeCripto: 'Comisión por retiro en cripto',
                feeBanco: 'Comisión por retiro en banco',
                feeRetiro: 'Comisión por retiro a tarjeta',
                comision1: '1% Por operación',
                comision2: '2% Por operación',
                titleCrypto: 'Transacciones con crypto',
                subtituloCrypto: 'Comisiones transparentes.',
                subtituloCrypto2: 'Para Persona Física y Persona Moral.',
            },
            seccion6:{
                titulo:'¿Cómo empezar a recibir pagos con criptomonedas?',
                subtitulo:'Incorporamos funciones tecnológicas-financieras y brindamos soluciones para la expansión de tu negocio.',
                ingresa:'1. Ingresa tu solicitud',
                ingresaDesc:'Registrate con nosotros y sube toda la documentación e información.',
                respuesta:'2. Respuesta a tu solicitud',
                respuestaDesc:'Nuestro departamento de cumplimiento te dará una respuesta en 48 Hrs.',
                bienvenido:'3. ¡Bienvenido a Wirebit!',
                bienvenidoDesc:'Recibirás un correo de bienvenida, en caso de dudas contáctanos.',
            },
            seccion7:{
                titulo:'¡Descarga Wirebit App!',
                subtitulo:'Administra en todo momento todos tus pagos en criptomonedas.',
            },
            seccion8:{
                titulo:'Todo lo que buscas para tu e-commerce',
                subtitulo:'Con Wirebit todo es posible, recibe y administra tus pagos mediante criptomonedas, tarjetas de crédito y tarjetas de débito.',
                comercio:'Quiero afiliar mi comercio y tienda online a Wirebit.',
                comercioDesc:'Saca todo el potencial de tu E-commerce en 3 pasos.',
                criptopagos:'Quiero recibir criptopagos en mi e-commerce.',
                criptopagosDesc:'Innova dentro de tu industria y llega a nuevos clientes.',
            },
            footer:{
                contactanos:'Contáctanos',
                texto1:'Whatsapp o correo electrónico',
                texto2:'Lunes a Viernes de 9:00 am a 6:00 pm',
                texto3:'horario del centro de México.',
                acerca:'Acerca de',
                privacidad:'Aviso de Privacidad',
                terminosCondiciones:'Términos y condiciones',
            },
        },
        faqs:{
            title:'Preguntas Frecuentes.',
            faqBtn1:'Wirebit',
            faqBtn2:'Mi Cuenta',
            faqBtn3:'Saldos y Cargos',
            faqBtn4:'Términos',
            section1:{
                title:'Acerca de Wirebit',
                S1faq1:'¿Qué es wirebit digital?',
                S1faq1Ans:'Es una plataforma digital que brinda herramientas para el procesamiento de pagos en criptomonedas, administración y uso de las mismas de una manera fácil y sencilla. Permitiendo así a sus clientes la entrada al nuevo mundo de las finanzas digitales.',
                S1faq2:'¿Qué es un procesador de pagos en criptomonedas?',
                S1faq2Ans:'Es una empresa responsable de administrar el flujo de las transacciones entre vendedores y compradores. Además de brindar herramientas tecnológicas y financieras para facilitar el uso de este nuevo activo financiero con potencial ilimitado.',
                S1faq3:'¿Qué productos ofrece Wirebit?',
                S1faq3Ans:'- Procesador de pagos para e commerce conectado vía API.',
                S1faq3Ans2:'- Servicios de carteras digitales (hot y cold wallets).',
                S1faq3Ans3:'- Cripto Tarjeta aceptada en más de 20 millones de establecimientos en el mundo.',
                S1faq3Ans4:'- Wirebit app, acceso a tu cuenta y control de tus activos 24/7.',
                S1faq4:'¿Cuáles criptos puedo procesar?',
                S1faq4Ans:'Las principales del mercado:',
                S1faq4Ans2:'Bitcoin, Litecoin, Ethereum, Dash, XRP, USDT Tether a través de la red Solana',
                S1faq5:'¿Cómo me protejo de la volatilidad de las criptomonedas?',
                S1faq5Ans:'Wirebit cuenta con las herramientas para minimizar este riesgo lo más posible y evitar la pérdida de valor por parte de nuestros usuarios.',
            },
            section2:{
                title:'Depósitos, saldos y cargos.',
                S2faq1:'¿Cuánto tiempo tarda en verse reflejado el dinero depositado en mi cuenta?',
                S2faq1Ans:'La operación tardará entre 24 y 48 horas en verse reflejada una vez hecha la solicitud.',
                S2faq2:'¿Mis pagos recibidos se mantienen como criptomonedas o se convierten en dinero?',
                S2faq2Ans:'Wirebit puede almacenar en criptomonedas o convertirlas en moneda de curso legal según la decisión de nuestros usuarios.',
                S2faq3:'¿Cuánto me cobran por recibir pagos en criptomonedas?',
                S2faq3Ans:'0%, recibe pagos en criptomonedas sin ningún costo de comisión.',
                S2faq4:'¿Puedo emitir facturas?',
                S2faq4Ans:'No es posible.',
                S2faq5:'¿Existe límite de venta con Wirebit digital?',
                S2faq5Ans:'No existe un límite de ventas.',
            },
            section3:{
                title:'Acerca de mi cuenta.',
                S3faq1:'¿La cuenta tiene algún costo?',
                S3faq1Ans:'No, la cuenta es totalmente gratuita.',
                S3faq2:'¿Existe un costo de mantenimiento por mi cuenta con Wirebit?',
                S3faq2Ans:'No existe un costo por mantenimiento.',
                S3faq3:'¿Desde qué país puedo abrir mi cuenta?',
                S3faq3Ans:'Desde la mayoría de países puedes abrirla.',
                S3faq4:'¿Tiene algún costo la tarjeta?',
                S3faq4Ans:'La Tarjeta Wirebit tienen un costo de emisión y envío de 15 dólares para clientes dentro del territorio Mexicano y 50 dólares para clientes internacionales.',
                S3faq5:'¿Puedo realizar retiros en efectivo con mi tarjeta de Wirebit?',
                S3faq5Ans:'Sí, puedes retirar dinero en efectivo desde cualquier ATM que procese tarjetas Visa, en este tipo de operaciones pueden acarrear cobro de comisiones por parte de los ATM.',
                S3faq6:'¿Qué documentos requieren para abrir una cuenta?',
                S3faq6Ans:'Documentación básica personal como identificación, comprobante de domicilio, identificación fiscal de tu país (para algunos servicios), etc.',
            },
            section4:{
                title:'Términos y condiciones',
                S4faq1:'¿Dónde puedo leer los términos y condiciones?',
                S4faq1Ans:'Para leer nuestros términos y condiciones puedes ingresar al siguiente link:',
                S4faq1Terms:'Ver términos y condiciones',
                S4faq2:'¿Dónde puedo leer el aviso de privacidad?',
                S4faq2Ans:'Para leer nuestro aviso de privacidad puedes ingresar al siguiente link:',
                S4faq2Terms:'Leer aviso de privacidad',
            },
        },
        card:{
            banner:{
                title:'La plataforma bancaria y financiera del futuro.',
                subtitle:'Tu tarjeta de debito Wirebit Visa te permite usar tus criptos cuando y donde quieras.',
                btn:'Solicita tu tarjeta',
            },
        },
    }
}
export default translate;
